import {
  BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue,
  BaseReactive302n39o7i5yop as BaseReactive,
  BaseListenable1u3g4s45l82o6 as BaseListenable,
} from './abstracts.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set3ct43wkzm94lj as set,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
  Never_getInstance1g83fzxrvq57k as Never_getInstance,
  get_state389x218zizu8a as get_state,
  beginUse146s8dwmfk72s as beginUse,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  lens2x0usmj7eco4 as lens_1,
  lens2po2j99uxhjgr as lens_2,
  set1ry2ssh8gkbcc as set_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  MutableValue2jbqb2a7km3rc as MutableValue,
} from './coreInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
} from './ReactiveState.mjs';
import { Default_getInstancee1f46otjvolq as Default_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SignalClass;
function Signal() {
  if (SignalClass === VOID) {
    class $ extends BaseReactiveValue() {
      constructor(startValue) {
        return new.target.new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(startValue);
      }
      static new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(startValue) {
        return this.new_com_lightningkite_reactive_core_BaseReactiveValue_bwum4c_k$(startValue);
      }
    }
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).set_revjhg_k$ = set;
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, 'Signal', VOID, VOID, [MutableReactiveValue()], [1]);
    SignalClass = $;
  }
  return SignalClass;
}
function _Constant___init__impl__v45mub(value) {
  return value;
}
function _Constant___get_value__impl__gl47rj($this) {
  return $this;
}
function Constant__addListener_impl_a5dmn8($this, listener) {
  return Never_getInstance().NOOP_RELEASE_1;
}
function Constant__toString_impl_pfy7ct($this) {
  return 'Constant(value=' + toString($this) + ')';
}
function Constant__hashCode_impl_3osajy($this) {
  return $this == null ? 0 : hashCode($this);
}
function Constant__equals_impl_wsq65y($this, other) {
  if (!(other instanceof Constant()))
    return false;
  var tmp0_other_with_cast = other.value_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ConstantClass;
function Constant() {
  if (ConstantClass === VOID) {
    class $ {
      constructor(value) {
        this.value_1 = value;
      }
      get_value_j01efc_k$() {
        return _Constant___get_value__impl__gl47rj(this.value_1);
      }
      addListener_6y9mct_k$(listener) {
        return Constant__addListener_impl_a5dmn8(this.value_1, listener);
      }
      toString() {
        return Constant__toString_impl_pfy7ct(this.value_1);
      }
      hashCode() {
        return Constant__hashCode_impl_3osajy(this.value_1);
      }
      equals(other) {
        return Constant__equals_impl_wsq65y(this.value_1, other);
      }
    }
    protoOf($).get_state_wc71uu_k$ = get_state;
    protoOf($).beginUse_omrbby_k$ = beginUse;
    initMetadataForClass($, 'Constant', VOID, VOID, [ReactiveValue()]);
    ConstantClass = $;
  }
  return ConstantClass;
}
var RawReactiveClass;
function RawReactive() {
  if (RawReactiveClass === VOID) {
    class $ extends BaseReactive() {
      constructor(start) {
        return new.target.new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$(start);
      }
      static new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$(start) {
        start = start === VOID ? Companion_getInstance().notReady_1 : start;
        return this.new_com_lightningkite_reactive_core_BaseReactive_2kvjp3_k$(start);
      }
      set_state_wnfcx0_k$(value) {
        super.set_state_wnfcx0_k$(value);
      }
      get_state_wc71uu_k$() {
        return super.get_state_wc71uu_k$();
      }
    }
    initMetadataForClass($, 'RawReactive', $.new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$);
    RawReactiveClass = $;
  }
  return RawReactiveClass;
}
var BasicListenableClass;
function BasicListenable() {
  if (BasicListenableClass === VOID) {
    class $ extends BaseListenable() {
      constructor() {
        return new.target.new_com_lightningkite_reactive_core_BasicListenable_biohma_k$();
      }
      static new_com_lightningkite_reactive_core_BasicListenable_biohma_k$() {
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$();
        $this.id_1 = Default_getInstance().nextInt_ak696k_k$(0, 100000);
        return $this;
      }
      toString() {
        return 'BasicListenable(' + this.id_1 + ')';
      }
      invokeAll_w2le0p_k$() {
        super.invokeAllListeners_uusj2y_k$();
      }
    }
    initMetadataForClass($, 'BasicListenable', $.new_com_lightningkite_reactive_core_BasicListenable_biohma_k$);
    BasicListenableClass = $;
  }
  return BasicListenableClass;
}
var LateInitSignalClass;
function LateInitSignal() {
  if (LateInitSignalClass === VOID) {
    class $ extends BaseReactive() {
      constructor() {
        return new.target.new_com_lightningkite_reactive_core_LateInitSignal_q590qj_k$();
      }
      static new_com_lightningkite_reactive_core_LateInitSignal_q590qj_k$() {
        return this.new_com_lightningkite_reactive_core_BaseReactive_2kvjp3_k$();
      }
      valueSet_aujvv6_k$(value) {
        this.set_state_wnfcx0_k$(_ReactiveState___init__impl__fvdp9b(value));
      }
      unset_qi6921_k$() {
        this.set_state_wnfcx0_k$(Companion_getInstance().notReady_1);
      }
    }
    protoOf($).lens_drj4fu_k$ = lens_1;
    protoOf($).lens_u4wb4z_k$ = lens_2;
    protoOf($).set_revjhg_k$ = set_0;
    initMetadataForClass($, 'LateInitSignal', $.new_com_lightningkite_reactive_core_LateInitSignal_q590qj_k$, VOID, [MutableReactive(), MutableValue()], [1]);
    LateInitSignalClass = $;
  }
  return LateInitSignalClass;
}
//region block: exports
export {
  BasicListenable as BasicListenable3uz4a8xs34a0h,
  Constant as Constant3smypj7m9af27,
  LateInitSignal as LateInitSignal30crwrg540xyy,
  RawReactive as RawReactive253xb355brtjj,
  Signal as Signal1973xs1vkmdcb,
  _Constant___init__impl__v45mub as _Constant___init__impl__v45mub2qfk15kh5l39c,
};
//endregion

//# sourceMappingURL=signals.mjs.map
